import { fetcher } from '@commenda/utils';

export type UpdateBusinessEntityDocumentParams = {
  fileName: string;
  fileUrl: string;
};

const updateBusinessEntityDocument = async (
  businessEntityId: number,
  documentId: number,
  body: UpdateBusinessEntityDocumentParams
) => {
  const response = await fetcher(
    `business-entities/${businessEntityId}/documents/${documentId}`,
    {
      method: 'PATCH',
      body,
    }
  );

  return response;
};

export { updateBusinessEntityDocument };
